<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Vtex \ <span class="ActiveURL">Bullet Points Update</span></span>
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <span style="font-size:20px; font-weight:500" class="m-0">Bullet Points Update</span>

        <button
            class="btn btn-md btn-primary"
            style="float:right; background-color:white; color:black;">
          <download-excel :data="ProductMasterUpload.DataModel.UIData.VtexProductTemplate"   name="VtexProduct_Templates"><span style="marige-top:10px;" > Download Template </span>   </download-excel>  </button>

      </d-card-header>
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="pricing">
                <d-form-row>
                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Product Master file *</label>
                    <div class="col-md-7" v-if="ProductMasterUpload.DataModel.UIData.UploadedDataCount == 0">   
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>
                          <!-- :disabled="(ProductMasterUpload.DataModel.UIData.ProductMasterList.length == 0)" -->
                          <d-button type="button" id="submit" title="Please Select the panel"  class="btn-accent" :disabled="(ProductMasterUpload.DataModel.UIData.ProductMasterList.length == 0)" @click="ProductMasterUploadData" style="margin-right:10px" >upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>
                    </div>
                     <div class="col-md-7" v-if="ProductMasterUpload.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ ProductMasterUpload.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>

                 <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from file</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.Data.SynccentricScrapList}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Rejected</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.UIData.RejectedList.length}}</label>
                    </div>
                 </d-col>


                <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Progressed</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.UIData.Progressed}}</label>
                    </div>
                 </d-col>
                
                <d-col md="12" class="form-group row"  v-if="(ProductMasterUpload.DataModel.UIData.Progressed == ProductMasterUpload.DataModel.UIData.ProductMasterList.length) && ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="ProductMasterUpload.DataModel.UIData.RejectedList"   :name="ProductMasterUpload.DataModel.UIData.RejectedFileName"><span style="marige-top:10px;" > Download Reject List </span> </download-excel>
                    </d-button>
                    </div>

<div class style="text-align:center"  v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>         

                  </d-col>

                <!-- <div class style="text-align:center"  v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>          -->
 

                </d-form-row>

                <br />

              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="ProductMasterUpload.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
import $ from 'jquery'

export default {
  name: 'ProductMasterUpload',
   data() {
    return {
      ProductMasterUpload: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            ProductMaster:null,
            ProductMasterList:[],
            Token:null,
            Curd:null,
            CreatedBy:0
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            currentStep:0,
            Template:[],
            minMaxList:[],
            Progressed:0,
            RejectedList:[],
            AvailablityTemplate:[],
            RejectedFileName:null,
            ProductMasterList:[],
            ProductMasterList1:[],
            ProductMasterList2:[],
            ProductMasterList3:[],
            ProductMasterList4:[],
            ProductMasterList5:[],
            ProductMasterList6:[],
            ProductMasterList7:[],
            ProductMasterList8:[],
            ProductMasterList9:[],
            ProductMasterList10:[],
            AvailablityList:[],
            AvailablityTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0,
            VtexProductTemplate:[{
              _SkuId:0,
              _SkuName:null,	
              _ActivateSkuIfPossible:"Yes",	
              _SkuIsActive:"Yes",	
              _SkuEan:null,	
              _Height:null,	
              _ActualHeight:null,	
              _Width:null,	
              _ActualWidth:null,	
              _Length:null,	
              _ActualLength:null,	
              _Weight:null,	
              _ActualWeight:null,	
              _MeasurementUnit:null,	
              _UnitMultiplier:null,	
              _SKUReferenceCode:null,	
              _RewardValue:null,	
              _EstimatedDateArrival:null,	
              _ManufacturerCode:null,	
              _ProductId:null,	
              _ProductName:null,	
              _ProductShortDescription:null,	
              YES:null,	
              _ProductReferenceCodeId:null,	
              _ShowOnSite:null,	
              _CaptionLink:null,	
              _ProductDescription:null,	
              _ProductLaunchDate:null,	
              _Keywords:null,	
              _SiteTitle:null,	
              _MetaTagDescription:null,	
              _SupplierId:null,	
              _ShowOutOfStock:null,	
              _Kit:null,	
              _DepartmentId:null,	
              _DepartamentName:null,	
              _CategoryId:null,	
              _CategoryName:null,	
              _BrandId:null,	
              _Brand:null,	
              _CubicWeight:null,	
              _CommercialCondition:null,	
              _Stores:"1,2,3",	
              _Accessories:null,	
              _Similar:null,	
              _Suggestions:null,	
              _MostrarJunto:null,	
              _Attachment:null,	
              MainImage_URL:null,	
              AdditionalImages1_URL:null,	
              AdditionalImages2_URL:null,	
              AdditionalImages3_URL:null,	
              AdditionalImages4_URL:null,
            }]
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            }
          ]
        },
      },
    };
  },

  mounted(){
      this.ProductMasterUpload.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.ProductMasterUpload.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      // this.ListAllFromCountry();
  },
  methods: {

ClearFileData(){
     this.ProductMasterUpload.DataModel.Data.FromCountry = null;
     this.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 0;
     this.ClearUsersetup();
     document.getElementById("pricing").reset();
},

        panelOnchange(){
            this.ProductMasterUpload.DataModel.UIData.Template=[];
            this.ProductMasterUpload.DataModel.UIData.TemplateIsAvailable = false;
        },

        ClearUsersetup(){
            this.ProductMasterUpload.DataModel.UIData.Template = [];
            this.ProductMasterUpload.DataModel.UIData.TemplateIsAvailable = false;
            this.ProductMasterUpload.DataModel.Data.SynccentricScrapList = 0;
            this.ProductMasterUpload.DataModel.UIData.UploadStatus = false;
            this.ProductMasterUpload.DataModel.UIData.ProductMasterList=[];
            // this.cleareList();
        this.ProductMasterUpload.DataModel.Data.PanelInfo ={
          Name : null,
              Country:null
        }
        this.ProductMasterUpload.DataModel.Data.FromCountry =null;
        this.ProductMasterUpload.DataModel.UIData.UploadedDataCount= 0;
         document.getElementById("pricing").reset();
    },


    AddProduct : async (mythis) => {  
      let vm = mythis;
      var Token = sessionStorage.getItem("Token");
      mythis.ProductMasterUpload.DataModel.Data.Token = Token;
      mythis.ProductMasterUpload.DataModel.Data.CRUD = "BulletPointsUpdate";
      mythis.ProductMasterUpload.DataModel.Data.CreatedBy = Number(mythis.ProductMasterUpload.SessionInfo.PageInfo.userId);
      mythis.ProductMasterUpload.DataModel.UIData.UploadStatus = false;
      mythis.ProductMasterUpload.DataModel.UIData.RejectedList=[];
      mythis.ProductMasterUpload.DataModel.UIData.Progressed = 0;
      for (var i = 0; i < mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList.length; i++) {

          vm.ProductMasterUpload.DataModel.Data.ProductMaster = Utilities.JsonCopy(mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList[i]);
          var dataString = JSON.stringify(vm.ProductMasterUpload.DataModel.Data);
          vm.ProductMasterUpload.PageLoad = true;
          vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 0;
          vm.ProductMasterUpload.DataModel.UIData.RejectedFileName = "RejectedList" + " " + Date.now();
          
        try {
          let response = await axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString);
             if (response.data.ErrorInfo == null) {
               mythis.ProductMasterUpload.DataModel.UIData.Progressed+=1;
               mythis.ProductMasterUpload.PageLoad = false;
              if(response.data.Result.ProductMaster.ProductMasterError!=undefined ||  response.data.Result.SKUDetails.SKUDetailsError!=undefined)
              {
                if(response.data.Result.ProductMaster.ProductMasterError!=undefined)
                {
                 if(response.data.Result.ProductMaster.ProductMasterError.message!=undefined)
                  response.data.Result.ProductMaster.ProductMasterError =  response.data.Result.ProductMaster.ProductMasterError.message;
                 else if(response.data.Result.ProductMaster.ProductMasterError.Message!=undefined)
                  response.data.Result.ProductMaster.ProductMasterError =  response.data.Result.ProductMaster.ProductMasterError.Message;

                }
                     let failedProduct={
                        ...response.data.Result.SKUDetails,
                        ...response.data.Result.ProductMaster,
                }
                mythis.ProductMasterUpload.DataModel.UIData.RejectedList.push(Utilities.JsonCopy(failedProduct));
                mythis.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 1;
              }
          } else {
              console.log(response.data.ErrorInfo);
              mythis.ProductMasterUpload.PageLoad = false;
          }
        } catch (error) {
          console.log(error);
          mythis.ProductMasterUpload.PageLoad = false;
        }
       }
       this.$toaster.error("Task Comepeleted.");
    },
      
      ProductMasterUploadData(){
          $.when(
          // this.getData(this)
          this.AddProduct(this)
        ).then(console.log("success"), console.log("Failure"));

        this.ProductMasterUpload.DataModel.UIData.UploadStatus = true;
        
      },
 
 
 

    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },

    /**
     * Import table
     */
     importExcel(e) {

      const files = e.target.files;
      this.ProductMasterUpload.PageLoad = true;
      this.ProductMasterUpload.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.ProductMasterUpload.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = []; // Clear received data

          this.ProductMasterUpload.DataModel.Data.SynccentricScrapList = 0 ;
          this.ProductMasterUpload.DataModel.UIData.ProductMasterList = [];

          for (var i = 0; i < ws.length; i++) {

            var BulletPoint={
                FieldId: 0,
                FieldValueId: null,
                Text:null,
                productId:0
            };

            var ProductBO={
              Asin:null,  
              BulletPoints:[]
            }

            var BulletPoints= [];
            
            if(ws[i].Asin!=undefined)
                ProductBO.Asin = ws[i].Asin;
            else
                ProductBO.Asin = null;


            if(ws[i].UpcEAN_57!=undefined)
            {
            BulletPoint.FieldId=57,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].UpcEAN_57,
            BulletPoint.productId = null,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 
            
            if(ws[i].Weight_58!=undefined)
            {
            BulletPoint.FieldId=58,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].Weight_58,
            BulletPoint.productId = null,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

            if(ws[i].PartNo_59!=undefined)
            {
            BulletPoint.FieldId=59,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].PartNo_59,
            BulletPoint.productId = null,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

            if(ws[i].Dimensions_60!=undefined)
            {
            BulletPoint.FieldId=60,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].Dimensions_60,
            BulletPoint.productId = null,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 
            
            if(ws[i].Condition_70!=undefined)
            {
            BulletPoint.FieldId=70,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].Condition_70,
            BulletPoint.productId = null,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 
                if(ws[i].Color_71!=undefined)
            {
            BulletPoint.FieldId=71,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].Color_71,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 
            
            if(ws[i].Size_72!=undefined)
            {
            BulletPoint.FieldId=72,
            BulletPoint.FieldValueId= null,
            BulletPoint.Text= ws[i].Size_72,
            BulletPoints.push(Utilities.JsonCopy(BulletPoint));
            } 

            // ScrabData.CreatedBy = this.ProductMasterUpload.SessionInfo.PageInfo.userId;
            ProductBO.BulletPoints = Utilities.JsonCopy(BulletPoints);
            this.ProductMasterUpload.DataModel.UIData.ProductMasterList.push(Utilities.JsonCopy(ProductBO));
          }

          console.log(this.ProductMasterUpload.DataModel.UIData.ProductMasterList);
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          this.ProductMasterUpload.PageLoad = false;
        } catch (e) {
          console.log(e); 
            this.ProductMasterUpload.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },

  }
}
</script>